import React, { useState } from 'react';
import '../../../../../style/transformer/JournalDialog.scss';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { ITransformerInvoice } from '../../../../../@types/model/transformer/invoice/transformerInvoice';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import OutlinedStadiumButton from '../../../../customComponents/button/OutlinedStadiumButton';
import StadiumButton from '../../../../customComponents/button/StadiumButton';
import TransformerJournalHelper, { ITransformerJournal, TransformerJournalType } from '../../../../../@types/model/transformer/journal/journal';
import { IAuthState, IRootState } from '../../../../../@types/redux';
import { connect } from 'react-redux';
import moment from 'moment';
import generalFunctions from '../../../../../store/general/functions';
import TransformerTariffSplitTable from '../../../../customComponents/tariffTable/SplitTable';
import lodash from 'lodash';
import { Card } from '@material-ui/core';
import { IMunicipalityInvoice } from '../../../../../@types/model/transformer/invoice/municipalityInvoice';
import { ISPSInvoice } from '../../../../../@types/model/transformer/invoice/spsInvoice';
import ProjectDialog from '../../../../customComponentV2/dialog/ProjectDialog';
import Icon from '@material-ui/core/Icon';

interface ITransformerInvoiceJournalDialogProps {
    invoices : Array<ITransformerInvoice | IMunicipalityInvoice | ISPSInvoice>;
    type : TransformerJournalType;

    auth : IAuthState;

    onClose : () => void;
}

const TransformerInvoiceJournalDialogComponent = (props : ITransformerInvoiceJournalDialogProps) : React.ReactElement => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);

    const onClick = () : void => {
        setOpen(true);
    };

    const onClose = () : void => {
        setOpen(false);
        if (props.onClose) props.onClose();
    };

    const onConfirmClick = async () : Promise<void> => {
        setIsLoading(true);

        const { auth, type, invoices } = props;

        if (!auth.session) return;

        try {
            const lines = TransformerJournalHelper.getSplitLines(invoices);

            const journal : ITransformerJournal = {
                id: '',
                createdBy: auth.session.firebaseUser.uid,
                createdByEmployee: auth.session.employee.EmployeeNumber ?? '',
                createdByName: auth.session.employee.Name,
                createdOn: moment.utc().valueOf(),
                updatedBy: auth.session.firebaseUser.uid,
                updatedByEmployee: auth.session.employee.EmployeeNumber ?? '',
                updatedByName: auth.session.employee.Name,
                updatedOn: moment.utc().valueOf(),
                type,
                invoices,
                journalNumber: '',
                totalAccount: lodash.chain(lines).filter(x => x.description === 'ELECTRICITY').sumBy(x => x.amount).value() * -1,
                totalVat: lodash.chain(lines).filter(x => x.description === 'VAT').sumBy(x => x.amount).value(),
                totalInterest: lodash.chain(lines).filter(x => x.description === 'INTEREST').sumBy(x => x.amount).value(),
                lines,
                exported: false,
                exportedBy: null,
                exportedByEmployeeNumber: null,
                exportedByName: null,
                exportedOn: null,
                isWeb: true,
            };

            await TransformerJournalHelper.create(journal);

            generalFunctions.generalShowSuccessSnackbar('Success');
            setOpen(false);

        } catch (ex) {
            generalFunctions.generalShowError(ex);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <Button disabled={!props.invoices.length} variant='contained' color='primary' onClick={onClick}>
                <Icon style={{ marginRight: 10 }}><img src={`${ASSET_BASE}/assets/images/icons/submitted.svg`} /></Icon>
                JOURNAL
            </Button>
            <ProjectDialog
                isOpen={open}
                isLoadingCircular={isLoading}
                onClose={onClose}
                title={'JOURNAL'}
                fullScreen
            >
                <DialogContent className='fdc hfill bcg0'>
                    {
                        !props.invoices.some(x => !x.transformer.Company) &&
                        <Card className={'flx1 fdc mt15'}>
                            <TransformerTariffSplitTable invoices={props.invoices} />
                        </Card>
                    }
                    {
                        props.invoices.some(x => !x.transformer.Company) &&
                        <div className={'flx1 fdc mt15'}>
                            <Typography>{props.invoices.filter(x => !x.transformer.Company).map(x => x.transformer.EPNumber).join(', ')} have missing company data!</Typography>
                        </div>
                    }
                </DialogContent>
                <DialogActions className='bcg0'>
                    <OutlinedStadiumButton disabled={isLoading} className='mr16' variant='text' type='reset' onClick={onClose}>
                        CANCEL
                    </OutlinedStadiumButton>
                    <StadiumButton variant='contained' disabled={isLoading || props.invoices.some(x => !x.transformer.Company)} onClick={onConfirmClick}>
                        CONFIRM
                    </StadiumButton>
                </DialogActions>
            </ProjectDialog>
        </div>
    );
};

const mapStateToProps = (state : IRootState) => {
    return {
        auth: state.auth,
    };
};

const TransformerInvoiceJournalDialog = connect(
    mapStateToProps,
)(TransformerInvoiceJournalDialogComponent);

export default TransformerInvoiceJournalDialog;
